import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ApiError } from '@ac/library-api';

import { getBackgroundTasksErrors } from '@gss/store/backgroundTasks/selectors';
import { getConfigurationErrors } from '@gss/store/configuration/selectors';
import { getMainProcessErrors } from '@gss/store/mainProcess/selectors';
import { getSettingsErrors } from '@gss/store/settings/selectors';

interface SubscribedErrorState {
  errors: Array<ApiError | Error>;
  isError: boolean;
}

export const useSubscribedErrorState = (): SubscribedErrorState => {
  const backgroundTasksErrors = useSelector(getBackgroundTasksErrors);
  const configurationErrors = useSelector(getConfigurationErrors);
  const settingsErrors = useSelector(getSettingsErrors);
  const mainProcessErrors = useSelector(getMainProcessErrors);

  return useMemo((): SubscribedErrorState => {
    const errors = [
      backgroundTasksErrors,
      configurationErrors,
      settingsErrors,
      mainProcessErrors,
    ].flat();

    return {
      errors,
      isError: !!errors?.length,
    };
  }, [
    backgroundTasksErrors,
    configurationErrors,
    settingsErrors,
    mainProcessErrors,
  ]);
};
